'use strict'

module.exports = bail

function bail(err) {
  if (err) {
    throw err
  }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/bail/index.js
// module id = 544
// module chunks = 0 15 16 17 18